import { c as _c } from "react/compiler-runtime";
import { closestCenter, defaultDropAnimationSideEffects, DndContext, DragEndEvent, DragOverlay, DropAnimation, MeasuringStrategy, UniqueIdentifier } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React, { PropsWithChildren, useState, type JSX } from 'react';
import { DragActivator, useDragSensors } from 'shared/hooks/use-drag-sensors';
import DragOverlayPortal from './drag-overlay-portal';
const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4'
      }
    }
  })
};
interface SortableProps<T extends {
  id: number | string;
}> extends PropsWithChildren {
  draggable: (element: T) => JSX.Element;
  items: T[];
  onMove: (activeId: number, activeIndex: number, overIndex: number) => Promise<void>;
  disabled?: boolean;
  isPortal?: boolean;
  dragActivator?: DragActivator;
}
const Sortable = t0 => {
  const $ = _c(21);
  const {
    items,
    onMove,
    draggable,
    children,
    disabled,
    isPortal,
    dragActivator: t1
  } = t0;
  const dragActivator = t1 === undefined ? "item" : t1;
  const [activeId, setActiveId] = useState(null);
  const sensors = useDragSensors(dragActivator);
  let t2;
  if ($[0] !== activeId || $[1] !== children || $[2] !== disabled || $[3] !== draggable || $[4] !== isPortal || $[5] !== items || $[6] !== onMove || $[7] !== sensors) {
    let t3;
    if ($[9] !== activeId) {
      t3 = item => item.id === activeId;
      $[9] = activeId;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    const activeElement = items.find(t3);
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = async () => {
        setActiveId(null);
      };
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    const onDragCancel = t4;
    let t5;
    if ($[12] !== items || $[13] !== onMove) {
      t5 = async t6 => {
        const {
          active,
          over
        } = t6;
        if (over && active.id !== over?.id) {
          const activeIndex = items.findIndex(t7 => {
            const {
              id
            } = t7;
            return id === active.id;
          });
          const overIndex = items.findIndex(t8 => {
            const {
              id: id_0
            } = t8;
            return id_0 === over.id;
          });
          if (activeIndex > -1 && overIndex > -1) {
            await onMove(Number(active.id), activeIndex, overIndex);
          }
        }
        setActiveId(null);
      };
      $[12] = items;
      $[13] = onMove;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    const onDragEnd = t5;
    let t6;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        droppable: {
          strategy: MeasuringStrategy.Always
        }
      };
      t7 = t8 => {
        const {
          active: active_0
        } = t8;
        setActiveId(active_0.id);
      };
      $[15] = t6;
      $[16] = t7;
    } else {
      t6 = $[15];
      t7 = $[16];
    }
    let t8;
    if ($[17] !== children || $[18] !== disabled || $[19] !== items) {
      t8 = <SortableContext items={items} strategy={verticalListSortingStrategy} disabled={disabled}>{children}</SortableContext>;
      $[17] = children;
      $[18] = disabled;
      $[19] = items;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t2 = <DndContext sensors={sensors} collisionDetection={closestCenter} measuring={t6} onDragStart={t7} onDragEnd={onDragEnd} onDragCancel={onDragCancel}>{t8}{activeId && <>{isPortal ? <DragOverlayPortal dropAnimation={dropAnimationConfig} className="cursor-grabbing opacity-0">{activeElement ? draggable(activeElement) : null}</DragOverlayPortal> : <DragOverlay dropAnimation={dropAnimationConfig} className="cursor-grabbing opacity-0">{activeElement ? draggable(activeElement) : null}</DragOverlay>}</>}</DndContext>;
    $[0] = activeId;
    $[1] = children;
    $[2] = disabled;
    $[3] = draggable;
    $[4] = isPortal;
    $[5] = items;
    $[6] = onMove;
    $[7] = sensors;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default Sortable;